import './Table.scss'

import React, { Component } from 'react'
import cx from 'bem-classnames';

const Table = (props) => {

    let classes = {
        name: '-Table'
    }

    return (
        <table className={[cx(classes, props), props.className].join(' ')}>
          { props.children }
        </table>
    )
}

export default Table
